<template>
  <NuxtLoadingIndicator />

  <nav
    class="w-full bg-green-100 border-b border-grayborder p-4 dark:bg-zinc-800 dark:text-gray-300 dark:border-zinc-950 shadow-sm"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-start">
        <button
          data-drawer-target="logo-sidebar"
          data-drawer-toggle="logo-sidebar"
          aria-controls="logo-sidebar"
          type="button"
          class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
        >
          <span class="sr-only">Open sidebar</span>
          <svg
            class="w-6 h-6"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
            ></path>
          </svg>
        </button>
        <nuxt-link
          to="/"
          class="text-3xl font-extrabold flex flex-col ml-2 md:mr-24 text-gray-800 hover:text-zinc-950 dark:text-gray-200 hover:no-underline dark:hover:text-zinc-600"
        >
          <span class="logo-text">MSMax</span>
          <small class="text-sm">Mensagem em Massa</small>
        </nuxt-link>
      </div>

      <div class="flex gap-2">
        <MsmaxUsermenu />

        <div class="flex flex-row items-center justify-center hover:cursor-pointer">
          <!-- <button @click="toggleTheme">{{ colorMode.preference }}</button> -->
          <NuxtIcon
            name="darkmodeon"
            fillet
            v-show="colorMode.preference === 'light'"
            class="text-[30px] hover:text-gray-400"
            @click="toggleTheme"
          />
          <NuxtIcon
            name="darkmodeon"
            fillet
            v-show="colorMode.preference === 'light'"
            class="text-[30px] hover:text-gray-400"
            @click="toggleTheme"
          />
          <NuxtIcon
            name="darkmodeoff"
            fillet
            v-show="colorMode.preference === 'dark'"
            class="text-[30px] hover:text-gray-400"
            @click="toggleTheme"
          />
        </div>
      </div>
    </div>
  </nav>

  <div class="min-h-[calc(100vh-89px)] bg-gray-50 dark:bg-zinc-900">
    <slot />
  </div>
</template>

<script setup>
const colorMode = useColorMode();
const toggleTheme = () => {
  colorMode.preference = colorMode.preference === "dark" ? "light" : "dark";
};
</script>

<style lang="scss" scoped>
.logo-text {
  font-family: "Anta", sans-serif;
}
</style>
